module.exports = __webpack_public_path__ + "img/animals_03_H.586f3fc0.webp";